




import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import AddEditItem from '@/components/add-flows/AddEditItem.vue';
import { GenericItem } from '@/models/items/generic-item-model';

@Component({
  components: {
    AddEditItem
  }
})
export default class EditItem extends Vue {
  @Prop(GenericItem) public item: GenericItem;

  created() {
    
  }
}
